import _extends from "@babel/runtime/helpers/extends";
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { useMediaQuery } from '@mui/material';
import { EmbersButton } from '../button/button';
import { PROMETHEAN_BREAKPOINT_NAV_CHANGE } from '../styles/breakpoints/breakpoints';
export var EmbersTitleButton = function EmbersTitleButton(props) {
  var hideLabel = useMediaQuery("(max-width:".concat(PROMETHEAN_BREAKPOINT_NAV_CHANGE, "px)"));
  return /*#__PURE__*/React.createElement(EmbersButton, _extends({}, props, {
    labelHidden: props.labelHidden !== undefined ? props.labelHidden : hideLabel
  }));
};